<script setup lang="ts">
import { PopoverTrigger } from "reka-ui";

const props = defineProps({});
</script>

<template>
  <PopoverTrigger v-bind="{ ...props, ...$attrs }">
    <slot />
  </PopoverTrigger>
</template>
